module.exports = __webpack_public_path__ + "assets/img/icon-camera.bd046012.png";